import React from "react";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import { base_url, merchant_url } from "assets/utils/const";

class Successful extends React.Component {
  requestShopifyData = (encData, redirecturl) => {
    fetch(redirecturl, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        encData: encData,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.status == 200) {
            window.location.href = redirecturl;
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  requestShopify = (mercId, domUrl, agFlag) => {
    fetch(`${base_url}api/shopify/loginShopify`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: "",
        meId: mercId,
        domainURL: domUrl,
        aggFlag: agFlag,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.status == 200) {
            this.requestShopifyData(result.encData, result.redirectUrl);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  componentDidMount() {
    if (!localStorage.getItem("Authtoken")) {
      window.location.href = "/login";
    }
    var timeleft = 5;
    var downloadTimer = setInterval(function () {
      timeleft--;
      document.getElementById("countdowntimer").textContent = timeleft;
      if (timeleft <= 0) clearInterval(downloadTimer);
    }, 1000);

    setTimeout(() => {
      if (sessionStorage.getItem("shopifyVar") === "shopify") {
        let meId = sessionStorage.getItem("me-Id");
        let domainUrl = sessionStorage.getItem("domain-Url");
        this.requestShopify(meId, domainUrl, "Y");
      } else {
        window.location.href = `${merchant_url}`;
      }
    }, 5000);
  }
  render() {
    return (
      <>
        <section className="dv-Registration-content doc-main-div">
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">
                  Quick &amp; Easy Activation Process
                </h1>
                <div className="row">
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 1</div>
                      <div className="text">
                        Check email for Username &amp; OTP.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 2</div>
                      <div className="text">
                        Enter Username &amp; OTP. <br />
                        Set a desirable password.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 pr-0">
                    <div className="dv-step completed">
                      <div className="step">Step 3</div>
                      <div className="text">
                        Fill in all the details &amp; upload documents to start
                        activation process.
                      </div>
                    </div>
                  </div>
                </div>
                <ul className="tick mt-3 mr-5">
                  <li className="completed">
                    Business Overview <span className="hr-white"></span>{" "}
                  </li>
                  {/* <li className="completed">Business Contact Details <span className="hr-white"></span></li> */}
                  <li className="completed">
                    Business Contact Details <span className="hr-white"></span>
                  </li>
                  <li className="completed">
                    Bank Account Details <span className="hr-white"></span>
                  </li>
                  <li className="completed">Agreement &amp; KYC Documents</li>
                </ul>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <div className="dv-login-form dv-form pt-4">
                  <h1 className="section-heading border-heading no-border-heading">
                    Upload Successful
                  </h1>
                  <div className="successMsg text-center">
                    <img
                      src={require("assets/img/icons/success.png")}
                      className="img-success my-3"
                      alt="safexpay-img"
                    />
                    <h4 className="my-1 px-3 mxx-note">
                      An agreement copy has been sent to your registered email
                      address for your signature. Your KYC verification will be
                      completed within 3 hours.
                    </h4>
                    <h4 className="my-4 px-md-2">
                      Redirecting to Merchant Portal...{" "}
                      <span id="countdowntimer">5</span>
                    </h4>
                  </div>

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Successful;
